<template>
  <el-dialog title="模板产品(全部产品)" :visible.sync="viewVisible" custom-class="my-dialog-template select-tempalte-dialog" width="800px" :before-close="deleteDidNotSaveTemplate" @close="reload()" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
    <el-form :inline="true" class="my-form-template viewDialog" :model="searchParams">
      <el-form-item label="产品名称" prop="orderNo" class="less">
        <el-input type="text" placeholder="请输入" v-model="searchParams.productName" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="cxbt" type="warning" @click="search()">查询</el-button>
        <el-button class="addbtn" type="warning" @click="$refs.addProductRef.open(templateId,allProductIds,'')" v-if="isDefault!=1||showAdd" plain>新增</el-button>
      </el-form-item>
    </el-form>
     <el-tabs class="template-tab" v-model="activeName" @tab-click="handleClick" v-if="nav.length>0">
      <el-tab-pane :label="item.name" :name="item.themeId" v-for="(item) in nav" :key=item.themeId></el-tab-pane>
    </el-tabs>
    <el-table :data="tableData" stripe border class="list-table scroll-table" style="width: 100%" tooltip-effect="dark" v-loading="listLoading">
      <el-table-column type="index" width="80" label="序号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="name" label="产品名称" min-width="200" show-overflow-tooltip></el-table-column>
      <el-table-column prop="lowPrice" :sort-method="sortByPrice" sortable label="基础价格"  min-width="100" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div>
            <el-button type="text" @click="deleteItem(scope.row)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-pagination v-if="tableData.length>0" class="page" @size-change="pageNum=1;pageSize=$event;getList()" :pager-count="5" :current-page.sync='pageNum' :page-size.sync="pageSize" background layout="total, sizes, prev, pager, next, jumper" @current-change="getList()" :page-sizes="[10, 20, 50, 100]"  :total="total">
      </el-pagination> -->
    <div class="dialog-footer">
      <el-button type="warning" plain @click="deleteDidNotSaveTemplate()">取消</el-button>
      <el-button type="warning" class="bgBtn" @click="save" :loading="btnLoading">确定</el-button>
    </div>
    <addProduct ref="addProductRef" @reload="getList();countProductByType()"></addProduct>
  </el-dialog>
</template>
<script>
//当前实例组件
import {pageTool} from '@/api/mixins'
import addProduct from './addProduct.vue'
export default {
  mixins:[pageTool],
  // 选择模板产品
  data: () => ({
    activeName:'0',
    viewVisible: false,
    templateId:'', // 模板id
    nav: [],
    isDefault:'',
    showAdd:false,// 是否显示新增按钮
    allProductIds:[],// 当前页产品Id
    btnLoading:false,
    searchParams:{
      productName:'',
    }
  }),
  components:{addProduct},
  methods: {
    open(id,isDefault) {
      // 暂时删除的产品列表
      this.$store.commit('SET_REMOVEDPRODUCT',[])
      this.btnLoading=false
      this.showAdd = false
      this.templateId = ''
      this.activeName='0'
      this.isDefault = isDefault
      this.searchParams={}
      this.viewVisible = true
      if(id){
        this.templateId=id
        this.countProductByType()
        this.initListAjax('/master/productTemplate/queryProductList')
      }
    },
    search() {
      this.activeName='0'
      this.searchAjax()
      this.countProductByType()
    },
    countProductByType() {
      let param = {
        templateId:this.templateId,
        productName:this.searchParams.productName,
        queryAddible:''
      }
      this.$http({
        url: '/master/productTemplate/queryProductTheme',
        type: 'put',
        params: param,
      }).then( (data)=> {
        this.nav = data.data
      })
    },
    sortByPrice(obj1,obj2){
      let val1 = obj1.lowPrice
      let val2 = obj2.lowPrice
      return val1 - val2
    },
    //请求回调
    listCallback(res) {
      // 全部的产品Id
      this.allProductIds = res.allProductIds
      // 过滤当前列表已删除产品
      this.tableData = res.data.filter(item=>{
        return !this.$store.getters.removedProduct.some(ele=>ele.id === item.id)
      })
    },
    // 设置自定义参数
    setListParams(params) { 
      params.pageSize=99999999
      params.templateId = this.templateId
      params.productName = this.searchParams.productName
      params.queryAddible = ''
      params.themeId = this.activeName==0?'':this.activeName
    },
    // 关闭弹窗刷新列表页
    reload(){
      this.$emit('reload')
    },
    deleteDidNotSaveTemplate(){
      this.$http({
        url:'/master/productTemplate/delete',
        type:'DELETE',
        params:{
          id:this.templateId
        }
      }).then(res=>{
        this.viewVisible=false
      }).catch(e=>{this.viewVisible=false})
    },
    save() {
      // 保存前，过滤掉已删除的产品
      this.allProductIds = this.allProductIds.filter(res=>{
        return !this.$store.getters.removedProduct.some(item=> res == item.id)
      })
      if(this.allProductIds.length>0){
        this.btnLoading=true
        this.$http({
          url:'/master/productTemplate/saveTemplateProduct',
          type:'PUT',
          params:{
            templateId:this.templateId,
            productIds:this.allProductIds
          }
        }).then(res=>{
          this.btnLoading=false
          if(res.httpCode==200){
            this.$message.success('保存成功')
            this.viewVisible=false
            this.btnLoading=false
          }
        }).catch(e=>{
          this.btnLoading=false
        })
      }else{
        this.$message.warning('请至少选择一款产品')
      }
    },
    handleClick(){
      this.searchAjax()
    },
    deleteItem(item){
      this.showAdd = true
      this.tableData.map((res, index) => {
        if (res.id == item.id) {
          let deleteItem = this.tableData.splice(index, 1)
          // 获取已删除的产品
          this.$store.commit('SET_REMOVEDPRODUCT',[...deleteItem,...this.$store.getters.removedProduct])
        }
      })
    },
  },
  mounted() {},
}
</script>
<style lang='scss'>
.select-tempalte-dialog{
  .viewDialog{
    margin-bottom: 0px;
    .addbtn{
      height: 30px;
      padding: 0;
      width: 80px;
    }
  }
  .template-tab{
    .el-tabs__item {
      font-size: 14px;
    }
  }
  .list-table{
    margin-bottom: 32px;
    .el-table__row{
      height: 50px;
    }
    .cell{
      line-height: 25px;
    }
    &.scroll-table{
      .el-table__body-wrapper {
        max-height: 275px;
        overflow-y: scroll;
      }
    }
  }
  .dialog-footer{
    margin-top: 30px;
  }
}
</style>